import Paper from '@mui/material/Paper'
import { alpha } from "@mui/material/styles"

const StyledPaper = ({ children, classes = "", sx = {} ,height, width}) => {

  return (
    <Paper
      className={classes}
      elevation={4}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 1,
        m:1,
        borderRadius: 3,
        borderWidth: 2,
        borderStyle: 'solid',
        height,
        width,
        borderColor: theme => alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.1 : 0.5),
        backgroundColor: theme => alpha(theme.palette.paper, theme.palette.mode === 'dark' ? 0.05 : 0.5),
        backdropFilter: theme => theme.palette.mode === 'dark' ? "blur(3px)" : "blur(2px)",
        boxShadow: theme => theme.palette.mode === 'dark'
          ? '10px 20px 50px -5px rgba(0, 0, 0, 0.7)'
          : '10px 10px 30px 5px rgba(0, 0, 0, 0.5)',
        ...sx,
      }}
    >
      {children}
    </Paper>
  )
}

export default StyledPaper